import { DieBayerischeLogo } from "@App/Components/atoms/whitelabel/logos/DieBayerischeLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the Die Bayerische whitelabel.
 * Extends the default configuration with specific settings for Die Bayerische.
 */
export const config: Partial<Config> = {
  slug: "bayerische",
  navbar: {
    logos: {
      right: {
        component: <DieBayerischeLogo />,
      },
      left: {
        component: <RepareoLogo />,
      },
    },
    backToPartnerButton: {
      url: "https://www.diebayerische.de/",
    },
  },
  reviews: {
    show: true,
  },
  homeSections: {
    image: { src: "/images/partner/bayerische/bayerische_list_items.webp", alt: "die Bayerische" },
  },
};

export default config;
